import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf14fd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex flex-column align-items-center slot-container" }
const _hoisted_3 = {
  id: "fbx-damage-list",
  class: "damage-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!
  const _component_DotSubmissionConfirmation = _resolveComponent("DotSubmissionConfirmation")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!

  return (_ctx.confirmationShown)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ConfirmationOverlay, {
          acceptTheme: "primary",
          rejectText: "No",
          rejectTheme: "return",
          titleText: "You have reported the following damage on this trailer. Please confirm this is accurate.",
          acceptText: 
                _ctx.isLoading || _ctx.associationIsLoading ? 'Submitting' : 'Yes'
            ,
          confirmationLoading: _ctx.isLoading || _ctx.associationIsLoading,
          disabled: _ctx.isLoading || _ctx.associationIsLoading,
          onAccept: _ctx.onAccept,
          onReject: _ctx.onReject
        }, {
          warning: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordedTypes, (damage) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: damage?.type
                  }, " - " + _toDisplayString(_ctx.listItemTitle(damage?.type)), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["acceptText", "confirmationLoading", "disabled", "onAccept", "onReject"]),
        _createVNode(_component_DotSubmissionConfirmation, {
          dotInspectionExpired: _ctx.isAssessmentTrailerDotExpired,
          showConfirmation: _ctx.showDotConfirmation,
          submitting: _ctx.isLoading,
          onAccepted: _ctx.submitAssessment
        }, null, 8, ["dotInspectionExpired", "showConfirmation", "submitting", "onAccepted"]),
        (_ctx.hasError)
          ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
              key: 0,
              message: _ctx.error?.message,
              customBackFunc: _ctx.goBackToBeginningOfAssessment
            }, null, 8, ["message", "customBackFunc"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}